module.exports = __webpack_public_path__ + "static/media/card_icon_6.22f382ae.png";